import { AudioPlayer, DefaultText, MusicNote, PopupConfirm, styleVariables } from '@lib/common';
import { Space } from 'antd';
import styled from 'styled-components';
import { CloseOutlined, EditOutlined } from '@ant-design/icons';
import { AudioFileContainerDirection } from '../audio-file-base'; // TODO: remove it when the modal sizes are defined in the design system

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var DEFAULT_ICON_SIZE = 24;
var StyledContainer = styled(Space).withConfig({
  displayName: "audio-file-editcomponent__StyledContainer",
  componentId: "sc-1vaemqv-0"
})(["padding:", ";width:100%;border:1px solid ", ";border-radius:", ";"], function (_ref) {
  var $padding = _ref.$padding;
  return $padding === AudioFileContainerDirection.HORIZONTAL ? '8px 16px' : '16px';
}, styleVariables.colors.grey30, styleVariables.borderRadius.medium);
var StyledHorizontalContainer = styled.div.withConfig({
  displayName: "audio-file-editcomponent__StyledHorizontalContainer",
  componentId: "sc-1vaemqv-1"
})(["width:100%;display:flex;align-items:center;justify-content:space-between;gap:16px;"]);
var StyledHeader = styled(Space).withConfig({
  displayName: "audio-file-editcomponent__StyledHeader",
  componentId: "sc-1vaemqv-2"
})(["width:100%;display:flex;justify-content:space-between;align-items:center;"]);
var StyledInfo = styled(Space).withConfig({
  displayName: "audio-file-editcomponent__StyledInfo",
  componentId: "sc-1vaemqv-3"
})(["display:flex;gap:16px;align-items:center;"]);
var StyledAudioIconContainer = styled.div.withConfig({
  displayName: "audio-file-editcomponent__StyledAudioIconContainer",
  componentId: "sc-1vaemqv-4"
})(["display:flex;justify-content:center;align-items:center;background-color:", ";border-radius:", ";width:32px;height:32px;"], styleVariables.colors.primary20, styleVariables.borderRadius.medium);
var StyledActionContainer = styled.div.withConfig({
  displayName: "audio-file-editcomponent__StyledActionContainer",
  componentId: "sc-1vaemqv-5"
})(["display:flex;justify-content:center;align-items:center;gap:16px;"]);
var StyledAudioPlayer = styled(AudioPlayer).withConfig({
  displayName: "audio-file-editcomponent__StyledAudioPlayer",
  componentId: "sc-1vaemqv-6"
})(["width:100%;"]);
var StyledHorizontalAudioPlayerContainer = styled.div.withConfig({
  displayName: "audio-file-editcomponent__StyledHorizontalAudioPlayerContainer",
  componentId: "sc-1vaemqv-7"
})(["flex:1;"]);
var StyleFileName = styled(DefaultText).withConfig({
  displayName: "audio-file-editcomponent__StyleFileName",
  componentId: "sc-1vaemqv-8"
})(["font-size:", ";"], styleVariables.font.fontSizeSmall);
var StyleFileSize = styled(StyleFileName).withConfig({
  displayName: "audio-file-editcomponent__StyleFileSize",
  componentId: "sc-1vaemqv-9"
})(["color:", ";"], styleVariables.colors.grey70);
export var AudioFileEdit = function AudioFileEdit(_ref2) {
  var source = _ref2.source,
      fileSize = _ref2.fileSize,
      fileName = _ref2.fileName,
      onDelete = _ref2.onDelete,
      onEdit = _ref2.onEdit,
      label = _ref2.label,
      _ref2$direction = _ref2.direction,
      direction = _ref2$direction === void 0 ? AudioFileContainerDirection.VERTICAL : _ref2$direction,
      isLoading = _ref2.isLoading;

  var renderVerticalContent = function renderVerticalContent() {
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsxs(StyledHeader, {
        children: [/*#__PURE__*/_jsxs(StyledInfo, {
          children: [/*#__PURE__*/_jsx(StyledAudioIconContainer, {
            children: /*#__PURE__*/_jsx(MusicNote, {})
          }), /*#__PURE__*/_jsxs(StyleFileName, {
            children: [fileName, /*#__PURE__*/_jsxs(StyleFileSize, {
              children: [" | ", fileSize]
            })]
          })]
        }), onDelete && /*#__PURE__*/_jsx(PopupConfirm, {
          onConfirm: onDelete,
          okText: label.deleteOk,
          cancelText: label.deleteCancel,
          title: label.deleteTitle,
          children: /*#__PURE__*/_jsx(CloseOutlined, {
            color: styleVariables.colors.grey70,
            width: 12
          })
        })]
      }), /*#__PURE__*/_jsx(StyledAudioPlayer, {
        source: source,
        isAppliedRule: false
      })]
    });
  };

  var renderHorizontalContent = function renderHorizontalContent() {
    return /*#__PURE__*/_jsxs(StyledHorizontalContainer, {
      children: [/*#__PURE__*/_jsxs(StyledInfo, {
        direction: 'horizontal',
        align: "center",
        children: [/*#__PURE__*/_jsx(StyledAudioIconContainer, {
          children: /*#__PURE__*/_jsx(MusicNote, {})
        }), /*#__PURE__*/_jsxs(StyleFileName, {
          children: [fileName, /*#__PURE__*/_jsxs(StyleFileSize, {
            children: [" | ", fileSize]
          })]
        })]
      }), /*#__PURE__*/_jsx(StyledHorizontalAudioPlayerContainer, {
        children: /*#__PURE__*/_jsx(AudioPlayer, {
          source: source,
          isAppliedRule: false
        })
      }), /*#__PURE__*/_jsxs(StyledActionContainer, {
        children: [onEdit && /*#__PURE__*/_jsx(EditOutlined, {
          onClick: onEdit,
          color: styleVariables.colors.grey70,
          width: DEFAULT_ICON_SIZE
        }), onDelete && /*#__PURE__*/_jsx(PopupConfirm, {
          onConfirm: onDelete,
          okText: label.deleteOk,
          cancelText: label.deleteCancel,
          title: label.deleteTitle,
          disabled: isLoading,
          children: /*#__PURE__*/_jsx(CloseOutlined, {
            color: styleVariables.colors.grey70,
            width: DEFAULT_ICON_SIZE
          })
        })]
      })]
    });
  };

  var renderContent = function renderContent(direction) {
    switch (direction) {
      case AudioFileContainerDirection.HORIZONTAL:
        {
          return renderHorizontalContent();
        }

      case AudioFileContainerDirection.VERTICAL:
        {
          return renderVerticalContent();
        }
    }
  };

  return /*#__PURE__*/_jsx(StyledContainer, {
    direction: "vertical",
    $padding: direction,
    children: renderContent(direction)
  });
};